export * from './lib/components/modal/modal.component';
export * from './lib/components/modal-body/modal-body.component';
export * from './lib/components/modal-footer/modal-footer.component';
export * from './lib/components/modal-header/modal-header.component';
